export default class ConnectionError extends Error {
    constructor(response) {
        super(`Connection Error ${response.status} (${response.statusText}) at ${response.url}`);
        this.name = "ConnectionError";
        this.response = response;
    }
}
//# sourceMappingURL=ConnectionError.js.map